import React, { useState, useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import tw from 'twin.macro';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';


const Container = tw.div`bg-gradient-to-r from-blue-500 to-teal-400 px-8 py-4 rounded-lg border border-gray-200 shadow-lg flex flex-col items-center h-screen`;
const Title = tw.h1`text-4xl font-bold text-white mb-10`;
const Form = tw(animated.form)`w-full max-w-screen-md bg-white rounded-3xl shadow-xl p-8 mb-10 flex flex-col items-center sm:items-start`;
const FormControl = tw(animated.div)`w-full flex flex-col mb-6`;
const Label = tw.label`text-lg font-medium text-gray-700 mb-2`;
const Input = tw.input`p-3 border border-gray-300 rounded-lg focus:(outline-none ring-2 ring-teal-500) transition duration-200 w-full`;
const Select = tw.select`p-3 border border-gray-300 rounded-lg focus:(outline-none ring-2 ring-teal-500) transition duration-200 w-full`;
const ButtonGroup = tw.div`flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0 mt-8 w-full`;
const Button = tw(animated.button)`bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold uppercase tracking-wider transition duration-300 transform hover:(bg-teal-700 scale-105) focus:(outline-none ring-2 ring-teal-500 ring-offset-2 ring-offset-blue-500) disabled:(opacity-50 cursor-not-allowed) w-full sm:w-auto`;
const StatusMessage = styled.p`
  ${tw`text-green-600 font-semibold mt-1 mb-3`}
`;

const SessionTokenComponent = () => {
  const navigate = useNavigate();
  const [sessionToken, setSessionToken] = useState('');
  const [sessionTokenError, setSessionTokenError] = useState('');
  const [strategyName, setStrategyName] = useState('');
  const [strategyNameOptions, setStrategyNameOptions] = useState([]);
  const [isSessionActive, setIsSessionActive] = useState(false);
  const [statusMessage, setStatusMessage] = useState(false);
  const getToken = () => localStorage.getItem('token');

  const stopSession = () => {
    setIsSessionActive(false);
  };

  const axiosInstance = axios.create({
    baseURL: 'https://falcon-algo.onrender.com/api',
    headers: {
      'Authorization': `Bearer ${getToken()}`
    }
  });

  useEffect(() => {
    // Fetch user details and existing API key and secret key if they exist
    axiosInstance.get('/session-token')
      .then(response => {
        setSessionToken(response.data.token);
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
        } else {
          console.error('Error fetching user details:', error);
        }
      });
  }, [navigate]);

  useEffect(() => {
    // Fetch user details and existing API key and secret key if they exist
    axiosInstance.get('/configurations')
      .then(response => {
        const configurationsData =  response.data;
            // setConfigurations(configurationsData);

            const strategyNames = configurationsData.map(config => config.strategyName);
            setStrategyNameOptions(strategyNames);
            // setConfigurations(response.data);
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
        } else {
          console.error('Error fetching user details:', error);
        }
      });
  }, [navigate]);




  const handleNextClick = () => {
    // Validate inputs
    let valid = true;
    if (sessionToken === '') {
      setStatusMessage('Session Key is required')
      sessionTokenError('Session Key is required');
      valid = false;
    } else {
      setSessionTokenError('');
    }

    if (valid) {
      // Save API key and secret key
      axiosInstance.post('/session-token', { sessionToken })
        .then(response => {
          setStatusMessage('Session token saved successfully!');
          setSessionTokenError('');
        })
        .catch(error => {
          console.error('Error saving session token:', error);
          
        });
    } else {
      setStatusMessage('');
    }
  };

  const isDisabled = sessionToken === '';

  const titleProps = useSpring({ from: { opacity: 0, transform: 'translateY(-20px)' }, to: { opacity: 1, transform: 'translateY(0)' }, delay: 300 });
  const formProps = useSpring({ from: { opacity: 0, transform: 'translateX(20px)' }, to: { opacity: 1, transform: 'translateX(0)' }, delay: 700 });
  const buttonHoverProps = useSpring({ from: { transform: 'scale(1)' }, to: async (next) => {
    while (1) {
      await next({ transform: 'scale(1.05)' });
      await next({ transform: 'scale(1)' });
    }
  }, reset: true });

  return (
    <animated.div style={formProps}>
      <Container>
        <Title style={titleProps}>Session Management</Title>
        <Form>
          <FormControl>
            <Label htmlFor="sessionToken">Session Token</Label>
            <Input
              type="text"
              id="sessionToken"
              value={sessionToken}
              onChange={(e) => setSessionToken(e.target.value)}
              placeholder="Enter session token"
              required
            />
            {sessionTokenError && {sessionTokenError}}
          </FormControl>
          <FormControl>
            <Label htmlFor="strategyName">Strategy Name</Label>
            <Select id="strategyName" value={strategyName} onChange={(e) => setStrategyName(e.target.value)}>
              <option value="">Select a strategy</option>
              {strategyNameOptions.map((name, index) => (
                <option key={index} value={name}>{name}</option>
              ))}
            </Select>
          </FormControl>
          {statusMessage && <StatusMessage> {statusMessage}</StatusMessage> }
          <ButtonGroup>
            <Button style={buttonHoverProps} type="button" onClick={handleNextClick} disabled={isDisabled}>Start</Button>
            <Button style={buttonHoverProps} type="button" onClick={stopSession} disabled={!isSessionActive || isDisabled}>Stop</Button>
          </ButtonGroup>
        </Form>
       
      </Container>
    </animated.div>
  );
};

export default SessionTokenComponent;
